var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:[{
    'capitalize': _vm.capitalize,
    [`text-${_vm.textSize}`]: _vm.textSize,
    [`font-${_vm.fontWeight}`]: _vm.fontWeight,
    [_vm.textColor]: _vm.textColor,
    [`py-${_vm.paddingY}`]: _vm.paddingY,
    [`pb-${_vm.paddingBottom}`]: _vm.paddingBottom,
  }]},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.text)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }